import { ValidationError } from "sequelize"
import {
    OkrMetric,
    OkrMetricCreate,
    OkrMetricSave,
} from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import { LangType } from "client/store"
import {
    OkrMetricList,
    OkrMetricValidation,
} from "./types"


export const LoadOkrMetrics = (accountId: number) => (
    GET(`/okrMetric/accountId/${accountId}`)
    .then((metrics: OkrMetric[]) => {
        const metricList: OkrMetricList = {}
        metrics.forEach((metric) => {
            metricList[metric.id] = metric
        })

        const metricIds: number[] = []
        metrics.forEach((metric) => {
            metricIds.push(metric.id)
        })

        return { metricList, metricIds }
    })
)

export const LoadOkrMetricById = (
    metricId: number,
    accountId: number,
) => (
    GET(`/okrMetric/id/${metricId}/accountId/${accountId}`)
    .then((metric: OkrMetric) => metric)
)

export const SaveOkrMetric = (
    id: number,
    metric: OkrMetricCreate,
    lang: LangType,
) => {
    const data: OkrMetricSave = {
        id,
        metric,
    }
    return POST(
        "/okrMetric/save",
        JSON.stringify(data),
    ).then((res) => {
        const newMetric = res as OkrMetric
        const error = res as ValidationError
        return {
            newMetricId: newMetric.id || null,
            validation: <OkrMetricValidation>validate(error, lang),
        }
    })
}

export const DeleteOkrMetric = (
    metricId: number,
    accountId: number,
) => (
    DELETE(`/okrMetric/delete/${metricId}/${accountId}`)
    .then((removedRows: number) => removedRows)
)

export const CopyDefaultOkrMetrics = (
    accountId: number,
    defaultMetricsAssigned: boolean,
) => (
    GET(`/okrMetric/copyDefault/accountId/${accountId}/${defaultMetricsAssigned}`)
    .then((success: boolean) => success)
)
